module.exports = __webpack_public_path__ + "img/comment-arrow-up-right.f2b4a161.svg";